import initialState from './initialState';
import produce from 'immer';

export default (state = initialState.suit, action) => {
	switch (action.type) {
		case 'RESET_WHOLE_STATE':
			return initialState.suit;
		//
		case 'SET_SUIT':
			return produce(state, (draft) => {
				switch (action.value) {
					case 'heart':
						draft.bgposition = 0;
						break;
					case 'bell':
						draft.bgposition = 33.33;
						break;
					case 'leave':
						draft.bgposition = 66.66;
						break;
					case 'nut':
						draft.bgposition = 99.99;
						break;
					default:
						draft.bgposition = 99.99;
				}
			});

		case 'SHOW_SUIT':
			return produce(state, (draft) => {
				draft.showDialog = action.value;
			});

		case 'SHOW_CHOSEN_SUIT':
			return produce(state, (draft) => {
				draft.showChosenSuit = action.value;
			});

		default:
			return state;
	}
};
